import React, { useEffect } from "react";
import {
  Form,
  Input,
  Modal as AntdModal,
  Icon,
  InputNumber,
  Row,
  Col,
  useState,
} from "antd";

const Modal = (props) => {
  const { content, visible, onCancel = () => {}, onConfirm = () => {} } = props;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <AntdModal
      destroyOnClose={true}
      title={"审核通过"}
      visible={visible}
      onOk={handleConfirm}
      onCancel={onCancel}
      width={710}
      wrapClassName={"modal"}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Icon
          type="info-circle"
          theme="filled"
          style={{ marginRight: 10, color: "#FAAD14" }}
        />
        {content}
      </div>
    </AntdModal>
  );
};

export default Form.create()(Modal);
